// UserDataComponent.js
import React, { useEffect, useState } from "react";

function UserDataComponent() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch("https://www.denisbitter.de/stage01/api/admin_dashboard.php");
        const result = await response.json();
        if (result.success) {
          setUsers(result.data);
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError("Fehler beim Abrufen der Benutzer.");
      }
    };
    fetchUsers();
  }, []);

  return (
    <div className="mb-10">
      <h2 className="text-sm font-semibold mb-4">Benutzerverwaltung</h2>
      {error && <p className="text-red-500">{error}</p>}
      <table className="w-full table-auto border-collapse shadow-md">
        <thead>
          <tr className="bg-black text-orange-50 font-mono text-xs">
            <th className="border px-4 py-1">ID</th>
            <th className="border px-4 py-1">Name</th>
            <th className="border px-4 py-1">Vorname</th>
            <th className="border px-4 py-1">E-Mail</th>
           
            <th className="border px-4 py-1">Erstellt am</th>
            <th className="border px-4 py-1">Password</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="text-xs">
              <td className="border px-4 py-2">{user.id}</td>
              <td className="border px-4 py-2">{user.last_name}</td>
              <td className="border px-4 py-2">{user.first_name}</td>
              <td className="border px-4 py-2">{user.email}</td>
              
              <td className="border px-4 py-2">{user.created_at}</td>
              <td className="border px-4 py-2">{user.must_change}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UserDataComponent;
